import store from '../store';

export const department = () => {

    const departmentData = store.get("departmentList");
    const selectedDepartment = store.get("searchOption");
    let selected = "";

    if(selectedDepartment.Department.DepartmentId){
        selected = selectedDepartment.Department.DepartmentId;
    }

    const all = [`
        <option value="">Vis alle</option>
    `];

    const departmentArr = departmentData.map(depData => {

        if(selected === depData.DepartmentId){
            return `
                <option value="${depData.DepartmentId}" selected>
                    ${depData.Name}
                </option>
            `
        }

        return `
            <option value="${depData.DepartmentId}">
                ${depData.Name}
            </option>
            `
    });

    return [...all,...departmentArr].join("");
};